/* eslint-disable @typescript-eslint/naming-convention */
import type { ComponentProps } from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { Input as OriginalInput } from '@change-corgi/design-system-legacy/components/forms';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { InputError } from './InputError';

type Props = Omit<ComponentProps<typeof OriginalInput>, 'error'> & {
	error: TranslationKey | null | undefined;
	isSunriseEnabled: boolean;
	marginBottom?: string;
};

export const Input = ({ error, isSunriseEnabled, marginBottom, ...props }: Props): React.JSX.Element => {
	const containerSx = {
		marginBottom: marginBottom || '16px',
		'& label span': {
			fontSize: 12,
			fontWeight: 'bold',
			color: 'sunrise.semantic.typography.strong',
		},
		'& label button span': {
			fontSize: 18,
		},
		'& [id$=___error] > span': {
			marginLeft: '-4px',
			color: 'sunrise.semantic.typography.error',
		},
		'& [id$=___error] span svg': {
			marginRight: '4px',
			color: 'sunrise.semantic.icon.error',
		},
		'& > input': {
			fontSize: 16,
			lineHeight: ['24px', '20px'],
			margin: '8px 0',
			boxShadow: 'none',
		},
	};

	if (isSunriseEnabled) {
		return (
			<Box sx={containerSx}>
				<OriginalInput {...props} error={InputError({ translationKey: error })} />
			</Box>
		);
	}
	return <OriginalInput {...props} error={InputError({ translationKey: error })} />;
};
